









































import {
  defineComponent,
  reactive,
  ref,
  computed,
  SetupContext,
  watch,
} from '@vue/composition-api';

const Component = defineComponent({
  name: 'LoginForm',

  setup(_, { root: { $store, $router } }: SetupContext) {
    const data = reactive({
      email: '',
      password: '',
    });

    const rules = {
      emailRules: [
        (v: string) => !!v || 'E-mail is required',
        (v: string) =>
          /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          'E-mail must be valid',
      ],
      passwordRules: [
        (v: string) => !!v || 'Password is required',
        (v: string) => v.length > 5 || 'Password is too short',
      ],
    };

    const dataIsValid = ref(false);
    const passwordVisible = ref(false);
    const loginError = ref(null);

    function togglePasswordVisibility() {
      passwordVisible.value = !passwordVisible.value;
    }

    const loading = computed(() => {
      return $store.getters['userModule/loading'];
    });

    function login() {
      $store
        .dispatch('userModule/login', data)
        .then(() => {
          $router.push('/');
        })
        .catch(err => {
          if (err.detail) loginError.value = err.detail;
        });
    }

    watch(
      () => data.email,
      () => (loginError.value = null),
    );

    watch(
      () => data.password,
      () => (loginError.value = null),
    );

    return {
      data,
      dataIsValid,
      passwordVisible,
      loginError,
      rules,
      togglePasswordVisibility,
      loading,
      login,
    };
  },
});

export default Component;
